@let handlingProviders = isHandlingProviders();
<app-pan-modal #newCameraProviderModal [topLevel]="false" [shouldBodyScroll]="false" size="sm">
  <div header>Add New Camera Provider</div>
  <div body>
    <app-pan-form-control>
      <app-pan-floating-label>Camera Provider</app-pan-floating-label>
      <ng-select
        class="w-full mb-2"
        bindLabel="client_name"
        placeholder="Select camera provider..."
        [items]="allCameraProviders()"
        [(ngModel)]="newCameraProvider"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.client_name }}
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          {{ item.client_name }}
          <p class="text-sm italic">{{ item.provider_branch_id }} ({{ item.camera_provider }})</p>
        </ng-template>
      </ng-select>
    </app-pan-form-control>
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Cancel</app-pan-button>
    <app-pan-button panModalClose color="primary" (click)="addCameraProvider()" [disabled]="!newCameraProvider()"
      >Add Camera Provider</app-pan-button
    >
  </div>
</app-pan-modal>

<app-pan-section-header class="mt-4" title="Camera Providers">
  <app-pan-button
    panRole
    [roles]="['admin']"
    action
    icon="add"
    color="primary"
    [disabled]="handlingProviders"
    (click)="newCameraProviderModal.show()"
  ></app-pan-button>
</app-pan-section-header>

<ag-grid-angular [rowData]="cameraAliases()" [columnDefs]="cameraProviderColumns" [gridOptions]="cameraProviderTable"></ag-grid-angular>
